import { atom } from 'recoil';

import { setColorTheme } from 'utils/dom';

const localStorageEffect =
  key =>
  ({ setSelf, onSet }) => {
    const savedValue = localStorage.getItem(key);
    if (savedValue != null) {
      setSelf(savedValue);
      setColorTheme(savedValue);
    }

    onSet(newValue => {
      localStorage.setItem(key, newValue);
    });
  };

export const ModeAtom = atom({
  key: 'themeMode',
  default: 'light',
  effects: [localStorageEffect('theme')],
});
